export default "__VITE_ASSET__niSyjM97__"